// extracted by mini-css-extract-plugin
export default {"list":"eUP6Ob","item":"wjsM4g","link":"Dm3veo"};